import React from "react";

import footer from "../../assets/svg/footer.svg";
import seloabffooter from "../../assets/Images/seloabffooter.png";
import selopegn2025 from "../../assets/Images/selopegn2025.png";
import seloabf2026 from "../../assets/Images/seloabf2026.png";
import seloempresaamiga from "../../assets/Images/seloempresaamiga.png";
import selopequenoprincipe from "../../assets/Images/selopequenoprincipe.png";
// import logofooter from "../../assets/svg/logofooter.svg";

import {
  ButtonBox,
  ButtonBoxButton,
  Container,
  FooterContainer,
  Line,
  Regulamentation,
  Selo,
  SpanCnpj,
  Content,
  InfoContent,
} from "./styles";

interface IFooter {
  active?: boolean;
}

export const Footer: React.FC<IFooter> = ({ active }) => {
  return (
    <Container>
      <ButtonBox active={active}>
        <ButtonBoxButton>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://franquias.thebestacai.com.br/pt?utm_source=site-b2c&utm_medium=referral&utm_campaign=seja-franqueado-site-b2c"
          >
            Seja um Franqueado
          </a>
        </ButtonBoxButton>
      </ButtonBox>
      <FooterContainer img={footer}>
        <Content>
          <InfoContent>
            <div>
              <SpanCnpj>CNPJ 28.976.949/0001-84</SpanCnpj>
              <br />
              <SpanCnpj>GRUPO THE BEST FRANCHISING LTDA.</SpanCnpj>
            </div>
            <div>
              <a
                href="https://franquias.portaldofranchising.com.br/franquia-the-best-acai/"
                target="blank"
                className="img"
              >
                <Selo src={seloabf2026} alt="Selo ABF 2026" />
              </a>
              <a
                href="https://franquias.portaldofranchising.com.br/franquia-the-best-acai/"
                target="blank"
                className="img"
              >
                <Selo src={seloabffooter} alt="Selo ABF 2024" />
              </a>
              <a
                href="https://revistapegn.globo.com/melhores-franquias/noticia/2025/06/conheca-as-franquias-5-estrelas-do-premio-as-melhores-franquias-do-brasil-2025.ghtml"
                target="_blank"
                rel="noreferrer"
                aria-hidden="true"
                className="img"
              >
                <Selo src={selopegn2025} alt="Melhores Franquias" />
              </a>
              <a
                href="https://hcl.org.br/empresas-amigas-do-hcl"
                target="_blank"
                rel="noreferrer"
                aria-hidden="true"
                className="img"
              >
                <Selo src={seloempresaamiga} alt="Empresa Amiga" />
              </a>
              <a
                href="https://pequenoprincipe.org.br/"
                target="_blank"
                rel="noreferrer"
                aria-hidden="true"
                className="img"
              >
                <Selo
                  src={selopequenoprincipe}
                  alt="Hospital Pequeno Príncipe"
                />
              </a>
            </div>
          </InfoContent>
          <Line />
          <InfoContent>
            <div>
              <Regulamentation>
                <a className="first-link" href="/regulamento-the-best-copa">
                  Regulamento The Best Copa
                </a>
                <a className="first-link" href="/regulamento">
                  Regulamento do Clube The Best
                </a>

                <a href="/privacidade">Privacidade de dados</a>
                <a href="/informacoes-nutricionais">Tabela nutricional</a>
                <a href="/seja-nosso-fornecedor">Seja nosso fornecedor</a>
                <a href="/trabalhe-conosco">Trabalhe Conosco</a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://gaa.digital/thebest"
                >
                  Canal de Denúncias
                </a>
              </Regulamentation>
              <span className="spanInfo">
                Imagens meramente ilustrativas. Consulte os restaurantes
                participantes. Todos os direitos reservados 2025.
              </span>
            </div>
            {/* <img className="logofooter" src={logofooter} alt="Logo" /> */}
          </InfoContent>
        </Content>
      </FooterContainer>
    </Container>
  );
};
